import { Injectable } from '@angular/core';
import { parse } from '@tinyhttp/content-disposition';
import { FileResponse } from '@unity/clients';
import { saveAs } from 'file-saver-es';

const dispositionHeader = 'content-disposition';
const filenameParam = 'filename';

@Injectable({
  providedIn: 'root',
})
export class DownloadService {
  public saveFile(fileResponse: FileResponse): void {
    if (!fileResponse.headers || !fileResponse.data) {
      throw new Error('Could not process download response.');
    }
    const header = parse(fileResponse.headers[dispositionHeader]);
    const filename = header.parameters[filenameParam] as string;
    saveAs(fileResponse.data, filename);
  }
}
